import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { useEditarConfigDeEnvelopeContext } from "../..";
import OrSpinner from "../../../../../../Components/Utils/OrSpinner";
import { AtualizarConfigEnvelopeDocumentoController } from "../../../../../../Controllers/Geral/ConfigEnvelope/ConfigEnvelopeDocumento/ConfigEnvelopeDocumentoControllers";
import useAsyncCallback from "../../../../../../hooks/useAsyncCallback";
import DocumentoASerInseridoNaConfiguracao from "../TabelaInserirDocumentoConfig/DocumentoASerInseridoNaConfiguracao";

interface IDocumentosConfigEnvelopeSelecionadosProps {
    mostrarRubricas?: boolean;
}

export default function DocumentosConfigEnvelopeSelecionados(
    props: IDocumentosConfigEnvelopeSelecionadosProps
) {
    const {
        documentosConfigEnvelope: {
            lst: lstDocumentosConfigEnvelope,
            update: updateList,
            loading: loadingDocumentos,
        },
        destinatariosConfigEnvelope: { loading: loadingDestinatarios },
    } = useEditarConfigDeEnvelopeContext();
    const {
        execute: atualizarOrdemConfigEnvelopeDocumento,
        loading: editando,
    } = useAsyncCallback(
        async (idConfigEnvelopeDocumento: number, novoNrOrdem: number) => {
            const configEnvelopeDocumento = lstDocumentosConfigEnvelope.find(
                (d) =>
                    d.ID_ENVELOPE_DOCUSIGN_CONFIG_DOCUMENTO ===
                    idConfigEnvelopeDocumento
            )!;
            await AtualizarConfigEnvelopeDocumentoController({
                ...configEnvelopeDocumento,
                NR_ORDEM: novoNrOrdem,
            }).then(updateList);
        }
    );

    const loading = Boolean(
        editando ||
            (props.mostrarRubricas && loadingDestinatarios) ||
            loadingDocumentos
    );

    return (
        <div className="mt-4">
            <DragDropContext
                onDragEnd={(result) => {
                    if (
                        result.destination &&
                        result.source.index !== result.destination.index
                    ) {
                        atualizarOrdemConfigEnvelopeDocumento(
                            Number(result.draggableId),
                            result.destination.index
                        );
                    }
                }}
            >
                <Droppable droppableId="tableDroppableDocSelecionados">
                    {(dropProvider) => (
                        <div
                            ref={dropProvider.innerRef}
                            {...dropProvider.droppableProps}
                        >
                            <OrSpinner
                                loading={loading}
                                wrapperLoadingClasses="w-100 d-flex justify-content-center"
                                loadingColor="primary"
                            >
                                {lstDocumentosConfigEnvelope?.length === 0 ? (
                                    <div className="text-center text-muted">
                                        Nenhum documento vinculado
                                    </div>
                                ) : (
                                    lstDocumentosConfigEnvelope
                                        ?.sort(
                                            (a, b) => a.NR_ORDEM - b.NR_ORDEM
                                        )
                                        .map((documento) => (
                                            <Draggable
                                                draggableId={documento.ID_ENVELOPE_DOCUSIGN_CONFIG_DOCUMENTO.toString()}
                                                index={documento.NR_ORDEM}
                                            >
                                                {(providedDrag) => (
                                                    <div
                                                        ref={
                                                            providedDrag.innerRef
                                                        }
                                                        {...providedDrag.draggableProps}
                                                        {...providedDrag.dragHandleProps}
                                                    >
                                                        <DocumentoASerInseridoNaConfiguracao
                                                            updateList={
                                                                updateList
                                                            }
                                                            configEnvelopeDocumentoBase={
                                                                documento
                                                            }
                                                            descricao={
                                                                documento.DS_DOCUMENTO ||
                                                                documento.DS_DOCUMENTO_PRODUTO
                                                            }
                                                            idVinculado={
                                                                documento.ID_ENVELOPE_DOCUSIGN_CONFIG_DOCUMENTO
                                                            }
                                                            tipoDocumento={
                                                                documento.DS_TIPO_DOCUMENTO
                                                            }
                                                            draggable
                                                            mostrarRubricas={
                                                                props.mostrarRubricas
                                                            }
                                                        />
                                                    </div>
                                                )}
                                            </Draggable>
                                        ))
                                )}
                                {dropProvider.placeholder}
                            </OrSpinner>
                        </div>
                    )}
                </Droppable>
            </DragDropContext>
        </div>
    );
}
